(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apps"] && !Shopify.designMode) return;
  try {
    
  /* Shopify Forms renders inside an OPEN shadow root (shopify-forms-embed), so theme CSS
     cannot reach it and the block settings only cover colors. This injects the brand
     typography for the submit button — same look as the "Apply Now" button on the Pro page
     (uppercase, letterspaced, rounded, gold hover). Open shadow root is a supported surface;
     if Forms ever closes it, this degrades silently to the block-setting colors. */
  (function () {
    var CSS =
      /* brand typography: the Forms app font picker has neither Inter nor Cinzel, so the
         app setting stays on Arial and these rules override it inside the shadow root */
      "*{font-family:var(--bb-font-sans,'Inter',system-ui,sans-serif)}" +
      "h1,h2,h3,h4,legend,[class*='title' i]{font-family:var(--bb-font-display,'Cinzel',serif);font-weight:600;letter-spacing:.02em}" +
      "button[type=submit]{font-family:var(--bb-font-sans,'Inter',system-ui,sans-serif);" +
      "text-transform:uppercase;letter-spacing:.16em;font-size:.78rem;font-weight:400;" +
      "border-radius:10px;padding:.95rem 2.6rem;cursor:pointer;transition:background .15s ease}" +
      "button[type=submit]:hover{background:#c89800!important}";
    function arm(el) {
      if (!el.shadowRoot || el.__bbStyled) return;
      el.__bbStyled = true;
      try {
        var s = new CSSStyleSheet();
        s.replaceSync(CSS);
        el.shadowRoot.adoptedStyleSheets.push(s);
      } catch (e) {
        var st = document.createElement('style');
        st.textContent = CSS;
        el.shadowRoot.appendChild(st);
      }
    }
    function scan() { document.querySelectorAll('shopify-forms-embed').forEach(arm); }
    new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
    scan();
  })();

  } catch(e) { console.error(e); }
})();
})();
